import useLocalStorageText from "./useLocalStorageText"

export default function useConfigPathStorage() {  
  const {getText, setText} = useLocalStorageText('configPath', '$.rootAccount');
  
  return {
    configPath: getText,
    setConfigPath: setText
  }
}
